import React from "react";
import styled from "styled-components";
import { useSelectStoreQuery } from "../../api/userAPI";
import reuseQueryStringV2 from "../../utils/reuseQueryStringV2";
import { useAppSelector } from "../../store/actions/action";

const ComfirmItem = () => {
  // 필터 없이 전체 매장 리스트를 가져오기 위한 쿼리
  const allStoreFilter: Filter = {
    sortSearchString: "최신순",
    newStoreSearchString: "",
    typeSearchArray: [],
    contentsSearchString: ""
  };
  const storeListAPI = useSelectStoreQuery(reuseQueryStringV2(allStoreFilter));
  const noticeData = useAppSelector((state) => state.noticeReduce);

  // beforeStores에 있는 매장들 중 유효한 정보가 있는 매장들만 필터링
  const selectedStores = storeListAPI?.data?.data?.filter((store: Store) =>
    noticeData.beforeStores && noticeData.beforeStores.includes(store.user_id)
  ) || [];

  return (
    <>
      {selectedStores.map((store: Store) => (
        <ComfirmItemSet key={store.user_id}>
          <span className="tag">
            {store.store_type_name}
          </span>
          <span className="title">
            {store.name}
            <span className="userId">{store.user_id}</span>
          </span>
        </ComfirmItemSet>
      ))}
    </>
  );
};

const ComfirmItemSet = styled.li`
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "center")}
  .tag {
    display: inline-block;
    width: 60px;
    height: 24px;
    line-height: 24px;
    border-radius: 12px;
    background-color: #f4f4f4;
    font-size: 14px;
    color: #60677d;
    text-align: center;
    flex-shrink: 0;
  }
  .title {
    flex-grow: 1;
    padding-left: 16px;
    ${({ theme }) => theme.textOverflow.singleLine()}
    font-size: 16px;
    font-weight: 700;
    .userId {
      position: relative;
      top: -1px;
      display: inline-block;
      margin-left: 8px;
      padding-left: 8px;
      border-left: 2px solid ${({ theme }) => theme.color.lineSecondary};
      color: ${({ theme }) => theme.color.quaternary};
      font-size: 14px;
      font-weight: 400;
    }
  }
`;

export default ComfirmItem;
